import { guardedApiRequest } from '@/calls/helpers';

const getChapters = async (exhibitionId, locale) => guardedApiRequest(`routes/get_chapters?exhibition_id=${exhibitionId}&lang=${locale}`, {
  method: 'GET',
});

const getChaptersDetail = async (id, locale) => guardedApiRequest(`routes/get_chapter?id=${id}&lang=${locale}`, {
  method: 'GET',
});

export {
  // eslint-disable-next-line
  getChapters,
  getChaptersDetail
};
